import AbstractValidator from './AbstractValidator';
import EmailAddress from './EmailAddress';

export default class NotEmailAddress extends AbstractValidator
{
    protected messageTemplates: Record<string, string> = {
        isEmail: 'Der Eingabewert darf keine E-Mail-Adresse enthalten.',
    };

    run()
    {
        let validator = new EmailAddress(this.value, {});

        validator.run();

        if (validator.error.length === 0)
        {
            this.error = this.getMessage('isEmail');
            return;
        }
    }
}